<template>
  <div class="page">
    <NavigationBar :title="t('message.ServiceNotification')" small />
    <div class="page-content" :style="{ paddingTop: `${envStore.pagePaddingTop || envStore.navigationBarHeight}px` }">
      <div v-for="(m, n) in notifyStore.notifyList" :key="n" class="box" @click="toUrl(m)">
        <div class="title">
          <div class="line-clamp-1">{{ m.title }}</div>
        </div>
        <div class="box_b">
          <img v-if="m.icon" class="img" :src="m.icon" />
          <img v-else class="img"
            src="data:image/png;base64,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" />
          <div class="box_content">
            <div class="text-#333 line-clamp-2 min-h-34">{{ m.content }}</div>
            <div class="text-#666 text-right mt-10">
              {{ getTime(m.pushTime) }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="notifyStore.loading" class="text-center">
        <Loading />
      </div>
      <div v-else-if="!notifyStore.notifyList.length" class="text-center pt10">
        <van-image :width="118" :height="118" :src="orderImg">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div class="text-14 text-#333 leading-20">{{ t("message.empty") }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onActivated } from "vue";
import { useI18n } from "vue-i18n";
import { Loading } from "vant";
import { Env } from "@voghion/fe-util";
import { navigateTo } from "@voghion/native-api";
import { useEnvStore } from "@/states/env";
import { useNotifyStore } from "@/states/notify";
import NavigationBar from "@/components/NavigationBar.vue";
import orderImg from "@/assets/images/empty/order@2x.webp";
import { formatLocalTime, convertUTCTimeToLocal } from '@/utils/time'

const env = Env.getInstance();

const { t } = useI18n();
const envStore = useEnvStore();
const notifyStore = useNotifyStore();

onActivated(() => {
  notifyStore.clearNotifyUnread(false,'list');
});

const getTime = (time) => {
  return formatLocalTime("DD/MM/YYYY HH:mm", convertUTCTimeToLocal(time));
};

const toUrl = (m) => {
  if (env.isEnvAppWebView) {
    navigateTo({ url: m.skipUrl });
  }
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background: #f8f8f8;

  .page-content {
    padding: 0 12px;

    .box {
      margin-top: 10px;
      padding: 12px;
      border-radius: 4px;
      background-color: #fff;

      .title {
        height: 20px;
        padding-bottom: 5px;
        font-weight: 600;
        font-size: 14px;
        color: #333;
        line-height: 20px;
        font-style: normal;
        border-bottom: 1px solid #f5f5f5;
      }

      .box_b {
        display: flex;
        padding-top: 12px;

        .img {
          display: block;
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 8px;
        }

        .box_content {
          flex: 1;
          padding-left: 10px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
